var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f69615e135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89 146 L 286.003906 146 L 286.003906 266.628906 L 89 266.628906 Z M 89 146 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f1fd665779"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 95 108.378906 L 225 108.378906 L 225 192 L 95 192 Z M 95 108.378906 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f69615e135)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0f4c5c",
    d: "M 282.433594 147.65625 C 280.113281 146.308594 277.234375 146.308594 274.890625 147.65625 L 93.183594 252.554688 C 90.222656 254.253906 88.792969 257.730469 89.664062 261.027344 C 90.554688 264.320312 93.535156 266.617188 96.933594 266.617188 L 278.640625 266.617188 C 282.804688 266.617188 286.179688 263.242188 286.179688 259.078125 L 286.179688 154.179688 C 286.203125 151.488281 284.773438 149 282.433594 147.65625 Z M 282.433594 147.65625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f1fd665779)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0f4c5c",
    d: "M 104.246094 191.902344 C 105.695312 191.902344 107.1875 191.527344 108.535156 190.742188 L 181.199219 148.792969 L 188.367188 161.222656 C 189.921875 163.894531 192.757812 165.53125 195.824219 165.53125 C 195.886719 165.53125 195.949219 165.53125 196.011719 165.53125 C 199.160156 165.46875 201.996094 163.6875 203.46875 160.914062 L 223.332031 122.941406 C 224.699219 120.332031 224.636719 117.203125 223.167969 114.636719 C 221.695312 112.089844 219.003906 110.453125 216.0625 110.347656 L 173.246094 108.566406 C 170.097656 108.378906 167.136719 110.015625 165.519531 112.710938 C 163.882812 115.402344 163.863281 118.757812 165.4375 121.472656 L 172.605469 133.902344 L 99.9375 175.828125 C 95.816406 178.210938 94.40625 183.472656 96.789062 187.59375 C 98.382812 190.347656 101.285156 191.902344 104.246094 191.902344 Z M 104.246094 191.902344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatics);
export default __webpack_public_path__ + "static/media/Statics.f4af6b61f82de9aaa93c92db9690ad73.svg";
export { ForwardRef as ReactComponent };